// Supported display currencies (formatting-only — NO FX conversion).
// Money is stored as integer minor units (×100) and is currency-agnostic; we
// simply label/format it with the project's chosen currency.

export const CURRENCIES = {
  AED: { code: 'AED', symbol: 'د.إ', locale: 'en-AE', label: 'UAE Dirham' },
  USD: { code: 'USD', symbol: '$', locale: 'en-US', label: 'US Dollar' },
  EUR: { code: 'EUR', symbol: '€', locale: 'de-DE', label: 'Euro' },
  SAR: { code: 'SAR', symbol: 'SR', locale: 'en-SA', label: 'Saudi Riyal' },
  GBP: { code: 'GBP', symbol: '£', locale: 'en-GB', label: 'Pound Sterling' },
};

export const DEFAULT_CURRENCY = 'AED';

export const CURRENCY_OPTIONS = Object.values(CURRENCIES).map((c) => ({
  value: c.code,
  label: `${c.code} — ${c.label}`,
}));

export function currencyMeta(code) {
  return CURRENCIES[(code || '').toUpperCase()] || CURRENCIES[DEFAULT_CURRENCY];
}
